const P = '/content-images/placeholder'

// Photo Presentation Booking Promo — PhotoPresentationBookingPromo.vue
export const photoPresentationPromoPlaceholder = `${P}/photo-presentation-promo-placeholder.webp`

// Premier Retouching Drawer — checkout-prepay/prepayContent.ts
export const premierRetouchingPlaceholder = `${P}/premier-retouching-placeholder.webp`
